import { jsx as a, jsxs as n } from "react/jsx-runtime";
import { Icon as s } from "../icon/icon.js";
import "react";
import { Text as d } from "../text/text.js";
import h from "clsx";
import { c as m, d as x, e as g, f as b } from "../../virginmediao2-momentum-icons-icons-fas-CfzopcU1.js";
import '../../assets/alert.css';const u = "_alert_1xo1v_1", f = "_alert__icon_1xo1v_53", v = "_alert__head_1xo1v_66", w = "_alert__dismiss_1xo1v_72", p = "_alert_actions_1xo1v_77", y = "_alert__body_1xo1v_89", e = {
  alert: u,
  "alert--background-bright": "_alert--background-bright_1xo1v_21",
  "alert--has-head": "_alert--has-head_1xo1v_30",
  "alert--success": "_alert--success_1xo1v_35",
  "alert--warning": "_alert--warning_1xo1v_41",
  "alert--error": "_alert--error_1xo1v_47",
  alert__icon: f,
  alert__head: v,
  alert__dismiss: w,
  alert_actions: p,
  alert__body: y
}, z = (t, r) => {
  switch (t) {
    case "error":
      return /* @__PURE__ */ a(
        s,
        {
          icon: r || b,
          size: "md",
          color: "error"
        }
      );
    case "success":
      return /* @__PURE__ */ a(s, { icon: r || g, size: "md", color: "success" });
    case "warning":
      return /* @__PURE__ */ a(
        s,
        {
          icon: r || x,
          size: "md",
          color: "warning"
        }
      );
    default:
      return /* @__PURE__ */ a(s, { icon: r || m, size: "md", color: "info" });
  }
}, E = ({
  title: t,
  variant: r = "warning",
  bright: o,
  className: _,
  children: l,
  customIcon: i,
  ...c
}) => /* @__PURE__ */ n(
  "div",
  {
    className: h(
      {
        [e.alert]: !0,
        [e["alert--background-bright"]]: !!o,
        [e["alert--has-head"]]: !!t,
        [e["alert--info"]]: r === "info",
        [e["alert--success"]]: r === "success",
        [e["alert--warning"]]: r === "warning",
        [e["alert--error"]]: r === "error"
      },
      _
    ),
    "data-testid": "alert",
    ...c,
    children: [
      /* @__PURE__ */ a("div", { className: e.alert__icon, "data-testid": "alert-icon", children: z(r, i) }),
      t && /* @__PURE__ */ a("div", { className: e.alert__head, "data-testid": "alert-title", children: /* @__PURE__ */ a(d, { as: "h2", size: "T300", weight: "bold", children: t }) }),
      /* @__PURE__ */ a("div", { className: e.alert__body, "data-testid": "alert-body", children: l })
    ]
  }
);
export {
  E as Alert,
  z as getIcon
};
